<template>
    <div id="editor-container">
      <h1 class='mb-10'>게시물 수정하기</h1>
      <table class="editor-table">
        <tbody>
          <tr>
            <td class="item">제목</td>
            <td class="contents">
              <v-row>
              <v-col
                cols="12"
                md="10"
                sm="10"
                class="pa-0 pl-3"
              >
              <v-text-field
                v-model="title"
                outlined
                placeholder="제목을 작성해주세요"
                hide-details="true"
              ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="2"
                sm="2"
                class="pa-0 pl-2"
              >
              <v-checkbox
                v-model="checkbox"
                hide-details="true"
                label="공지"
              ></v-checkbox>
              </v-col>
              </v-row>
            </td>
          </tr>
          <tr>
            <td class="item">내용</td>
            <td class="contents">
              <ckeditor
              id="ckeditor"
              :editor="editor" tag-name="textarea" v-model="editorData" :config="editorConfig" style="height:500px;">
              </ckeditor>
              <!-- <editor
                initialValue="<p>Initial editor content</p>"
                :init="{
                  height: 500,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap',
                    'searchreplace visualblocks code fullscreen',
                    'print preview anchor insertdatetime media',
                    'paste code help wordcount table'
                  ],
                  toolbar:
                    'undo redo | formatselect | bold italic | \
                    alignleft aligncenter alignright | \
                    bullist numlist outdent indent | help'
                }"
              >
              </editor> -->
            </td>
          </tr>
          <!-- <tr>
            <td class="item">첨부파일</td>
            <td class="contents">
                  <v-file-input
                    chips
                    multiple
                    show-size
                    counter
                    v-model="files"
                  ></v-file-input>
            </td>
          </tr> -->
        </tbody>
      </table>
      <div class="pa-8">
        <v-btn
          rounded
          min-width="200px"
          min-height="50px"
          class="btn-upload mr-3"
          elevation="0"
          @click="submit"
        >
          수정완료
        </v-btn>
        <v-btn
          rounded
          min-width="200px"
          min-height="50px"
          color="#f0f0f0"
          class="btn-cancel"
          elevation="0"
          @click="$router.go(-1)"
        >
          취소하기
        </v-btn>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import bus from '../../../plugins/bus.js'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import '@ckeditor/ckeditor5-build-classic/build/translations/ko'
import { mapGetters } from 'vuex'
import { uploader } from '../../../utils/UploadAdapter.js'
import { BASE_API_URL } from '../../../store/api'

const instance = axios.create({
  baseURL: BASE_API_URL
})

export default {
  name: 'ContentsEditor',
  data () {
    return {
      title: '',
      checkbox: false,
      editor: ClassicEditor,
      editorData: '',
      editorConfig: {
        // The configuration of the editor.
        extraPlugins: [uploader],
        height: '500px',
        language: 'ko'
      },
      files: [],
      types: ['qna', 'data', '', 'photo']
    }
  },
  mounted () {
    bus.$emit('end:spinner')
    this.type = this.types[this.$route.params.id]
    this.contentId = this.$route.params.bid
    this.fetchBoardContents(this.contentId, this.type)
    console.log('route', this.$route)
  },
  computed: {
    ...mapGetters('auth', ['isAuth', 'getUser'])
  },
  methods: {
    /**
     * 페이지가 마운트 되었을때 글의 상세 내용, 해당 글의 댓글을 서버에서 가져옴
     * @param {string} id 현재 글의 id
     * @param {string} type 현재 어떤 자료실에 있는지 판별
     * @returns {undefined} 아무것도 반환하지 않음
    */
    fetchBoardContents (id, type) {
      console.log(id, type)
      instance.get(`/edu/${type}/${id}`)
        .then(res => {
          // this.contents = res.data
          this.title = res.data.title
          this.checkbox = res.data.notice
          this.editorData = res.data.content
        }).catch(err => {
          console.error('fetchBoardContents', err)
        })
    },
    /**
     * 글 수정 함수
     * 글을 수정하고 확인을 눌렀을떄 수정된 내용을 form-data 형식으로 서버에 put 요청
     * @returns {undefined} 아무것도 반환하지 않음
     */
    submit () {
      const fd = new FormData()
      fd.append('title', this.title)
      fd.append('writer', this.getUser.email)
      fd.append('notice', Boolean(this.checkbox))
      fd.append('content', this.editorData)
      const router = this.$router
      instance.put(`/edu/${this.type}/${this.contentId}/`,
        fd, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: this.$store.state.auth.access
          }
        }
      ).then(res => {
        window.alert('수정되었습니다.')
        router.go(-1)
      }).catch(err => {
        console.log(err)
      })
      // axios({
      //   method: 'post',
      //   url: 'http://127.0.0.1:8000/edu/data/',
      //   data: fd,
      //   headers: {
      //     'Content-Type': 'multipart/form-data',
      //     Authorization: this.$store.state.auth.access
      //   }
      // })
      //   .then(function (response) {
      //     window.alert('저장되었습니다.')
      //     this.$router.go(-1)
      //   })
      //   .catch(function (response) {
      //     console.log(response)
      //   })
      // const fileList = []
      // for (const file of this.files) {
      //   fileList.push(file)
      //   console.log(file)
      // }
      // fd.append('files', JSON.stringify(fileList))
      // console.log(JSON.stringify(fileList))

      /* $.ajax({
        type: 'post',
        url: 'http://172.30.1.14:8889/edu/data/',
        data: fd,
        processData: false,
        contentType: false,
        beforeSend: (xhr) => {
          xhr.setRequestHeader('Authorization', access)
        },
        success: (data) => {
          console.log(data)
          window.alert('저장되었습니다.')
          this.$router.go(-1)
        },
        error: (err) => {
          console.log(err)
        }
      }) */
    }
  }
}
</script>

<style lang='scss'>

#editor-container{
  padding: 0 70px;
  text-align: center;
  font-family: 'Noto Sans KR', sans-serif;

  .ck-blurred.ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline{
    height: 500px !important;
  }

  .ck-editor__editable_inline {
    min-height: 500px !important;
    font-size: 18px;
  }
  .editor-table{
    width: 90%;
    margin: 0 auto;
    border-top: 2px solid #888;
    td{
      padding: 15px 25px;
    }
    .item{
        color: #212121;
        font-size: 1.3rem;
        line-height: 26px;
        padding: 20px 15px;
        font-weight: bold;
        border-bottom: 1px solid #aaa;
        background: #eee;
    }
    .contents {
       color: #212121;
        font-size: 1.3rem;
        line-height: 26px;
        padding: 20px 15px;
        border-bottom: 1px solid #aaa;
        background-color: rgba(240, 240, 240, 0.2)
    }
  }
  .btn-upload{
      font-size: 1.2rem !important;
      border-radius: 15px;
      border: 2px solid #2156d0;
      background-color: #2156d0;
      color: white;
  }
  .btn-cancel{
      font-size: 1.2rem !important;
      border-radius: 15px;
      border: 2px solid #777;
      color: #777;
  }
}
</style>
